export default __webpack_public_path__ + "static/media/tsr-bw-horizontal.57180d4a.svg";